/*
 * @Description: 活动中心报名审核api
 * @Author: liuwp
 * @Date: 2022-09-09 16:52:55
 * @LastEditors: liuwp
 * @LastEditTime: 2022-09-13 14:44:15
 */
import { apiBaseUrl } from 'yxt-biz-pc/packages/api';
/**
 * 员工报名详情
 */
export const getRecordApi = (recordId) => {
  return apiBaseUrl.get(`/enrollcenter/manage/records/${recordId}/detail`);
};
// // 审核中心活动详情
// export const getAcDetailApi = (id) => {
//   return apiBaseUrl.get(`/stu/ac/audit/${id}`);
// };
